import React, { useRef, useEffect } from 'react';
import useCollapsibleState from '../hooks/useCollapsibleState';

function CollapsibleSection({ id, title, children }) {
  const [isCollapsed, toggleCollapsed] = useCollapsibleState(id);
  const bodyRef = useRef(null);

  useEffect(() => {
    const el = bodyRef.current;
    if (!el) return;
    if (isCollapsed) {
      el.style.maxHeight = el.scrollHeight + 'px';
      // Force reflow
      el.offsetHeight; // eslint-disable-line no-unused-expressions
      el.style.maxHeight = '0px';
    } else {
      el.style.maxHeight = el.scrollHeight + 'px';
      const onEnd = () => {
        el.style.maxHeight = 'none';
      };
      el.addEventListener('transitionend', onEnd, { once: true });
      return () => el.removeEventListener('transitionend', onEnd);
    }
  }, [isCollapsed]);

  // On first render, set initial state without animation
  useEffect(() => {
    const el = bodyRef.current;
    if (!el) return;
    if (isCollapsed) {
      el.style.maxHeight = '0px';
    } else {
      el.style.maxHeight = 'none';
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={`collapsible-section ${isCollapsed ? 'collapsed' : ''}`}>
      <button
        className="collapsible-header"
        onClick={toggleCollapsed}
        aria-expanded={!isCollapsed}
      >
        <span className="collapsible-title">{title}</span>
        <span className={`chevron ${isCollapsed ? 'collapsed' : ''}`}>&#9654;</span>
      </button>
      <div className="collapsible-body" ref={bodyRef}>
        {children}
      </div>
    </div>
  );
}

export default CollapsibleSection;
